// Centralized API configuration
export const getBaseUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:4000";
  } else if (process.env.NODE_ENV === "production") {
    return "/benchmarks/stakeholder-insights-explorer";
  }
};

export const getFrontendUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3000";
  } else if (process.env.NODE_ENV === "production") {
    return "";
  }
};

export const getApiUrl = () => `${getBaseUrl()}/api`;
export const getDataUrl = () => `${getBaseUrl()}/data`;
